export interface PromptGroup {
  label: string;
  prompts: string[];
}

// Help and app-related prompts — always shown, not randomly sampled
export const GENERAL_HELP_PROMPTS: string[] = [
  'How do I import a recipe?',
  'Report a problem',
  'Suggest a feature',
];

export const RECIPE_HELP_PROMPTS: string[] = [
  'How do I edit this recipe?',
  'Report a problem',
  'Suggest a feature',
];

// Cooking question pools — a random selection is shown on each load
export const GENERAL_COOKING_POOL: string[] = [
  'What recipes can I make with high protein?',
  'Show me quick weeknight dinner ideas',
  'What are some healthy breakfast recipes?',
  'What pasta recipes do I have?',
  'What can I cook in under 30 minutes?',
  'Show me dessert recipes',
  'What Mexican recipes do I have?',
  'Suggest recipes for meal prep',
  'What Italian dishes can I make?',
  'Show me soup recipes',
  'Suggest some salad recipes',
  'What Asian recipes do I have?',
  'Show me appetiser ideas',
  'What slow cooker recipes do I have?',
  'Suggest some comfort food recipes',
  'What baking recipes do I have?',
  'What one-pot meals can I make?',
];

export const COLLECTION_HELP_PROMPTS: string[] = [
  'How do I add a recipe to this collection?',
  'Report a problem',
  'Suggest a feature',
];

export const COLLECTION_COOKING_POOL: string[] = [
  'What should I cook from this collection tonight?',
  'Which recipe in this collection is quickest to make?',
  'Suggest a recipe that would suit this collection',
  "What's the healthiest recipe in this collection?",
  'What do the recipes in this collection have in common?',
  'Which recipe in this collection is best for meal prep?',
  'What wine would pair with recipes in this collection?',
];

export const RECIPE_COOKING_POOL: string[] = [
  'What wine pairs well with this recipe?',
  'Can I substitute ingredients in this recipe?',
  'How can I make this recipe healthier?',
  'What sides go well with this dish?',
  'Can I make this recipe ahead of time?',
  'How do I store leftovers from this recipe?',
  "What's the origin of this recipe?",
  'Can I make this recipe vegetarian?',
  'How can I adjust the servings?',
  'What cooking equipment do I need for this?',
  'Can I freeze this dish?',
  'What are common mistakes to avoid with this recipe?',
  'How spicy is this recipe?',
  'Can I make this in a slow cooker?',
  "What's a good dessert to follow this?",
  "How do I know when it's done?",
  'Can I use a different protein?',
  'What garnishes work well with this?',
  'Is this recipe gluten-free?',
  'How can I make this dish more flavourful?',
];
